define.alias("shared/components/shared/credentials/password-input", "calendar/components/shared/credentials/password-input");